var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStrokeFace = function SvgStrokeFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#A6DADF",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "evenodd",
    d: "M7.72 8.63a.557.557 0 0 1 1.06 0c.074.23.288.385.53.385.54 0 .763.69.327 1.008a.557.557 0 0 0-.202.623.557.557 0 0 1-.858.623.557.557 0 0 0-.654 0 .557.557 0 0 1-.858-.623.557.557 0 0 0-.202-.623.557.557 0 0 1 .327-1.008.557.557 0 0 0 .53-.384m-.636 3.71a.5.5 0 0 0-.584.494 5.5 5.5 0 1 0 11 0 .5.5 0 0 0-.584-.493l-.008.001-.024.004-.094.015a46.913 46.913 0 0 1-1.571.226c-.984.125-2.21.247-3.219.247-1.01 0-2.235-.122-3.219-.247a46.916 46.916 0 0 1-1.571-.226l-.094-.015-.024-.004-.008-.001m9.378 1.085c-.297.045-.683.1-1.118.155-.995.125-2.27.254-3.344.254-1.074 0-2.349-.129-3.344-.254-.435-.055-.82-.11-1.117-.155a4.5 4.5 0 0 0 8.923 0m-.182-4.794a.557.557 0 0 0-1.06 0 .557.557 0 0 1-.53.384c-.54 0-.763.69-.327 1.008a.557.557 0 0 1 .202.623c-.166.513.421.94.858.623a.557.557 0 0 1 .654 0 .557.557 0 0 0 .858-.623.557.557 0 0 1 .202-.623.557.557 0 0 0-.328-1.008.557.557 0 0 1-.53-.384",
    clipRule: "evenodd"
  })));
};
export default SvgStrokeFace;